import React from 'react';

export default function Header({ text }) {
    return (
        <React.Fragment>
            <h2 style={{ marginBottom: '10px' }}>{text}</h2>
        </React.Fragment>
    );
}
